import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MsalModule } from '@azure/msal-angular';
import { OAuthSettings } from '../oauth';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PlanListComponent } from './plan-list/plan-list.component';
import { MeetingViewComponent } from './meeting-view/meeting-view.component';
import { LoginComponent } from './login/login.component';

@NgModule({
  declarations: [
    AppComponent,
    MeetingViewComponent,
    PlanListComponent,
    MeetingViewComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    MsalModule.forRoot({
      clientID: OAuthSettings.appId,
      authority: "https://login.microsoftonline.com/1bd8c5e9-0889-4eb3-8f17-564987cd3285"
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
